import { asyncRouterMap, constantRouterMap } from '@router'
import { SET_ROUTER_LIST } from '../mutation-types'

function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(role)
  } else {
    return true
  }
}

function filterAsyncRouter(routes, role) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(role, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRouter(tmp.children, role)
      }
      res.push(tmp)
    }
  })
  return res
}

const permission = {
  state: {
    routerList: constantRouterMap,
    permissionList: [],
  },
  getters: {
    routerList: state => state.routerList,
    permissionList: state => state.permissionList,
  },
  mutations: {
    [SET_ROUTER_LIST](state, routers) {
      state.permissionList = routers
      state.routerList = constantRouterMap.concat(routers)
    },
  },
  actions: {
    GetRouterList({ commit }, role) {
      return new Promise((resolve, reject) => {
        try {
          const permissionRouter = filterAsyncRouter(asyncRouterMap, role)
          commit('SET_ROUTER_LIST', permissionRouter)
          resolve()
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}

export default permission
